import { ReferralDomains as columns } from '../columnsConfig';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import {
  useGetReferralDomainsCountQuery,
  useGetReferralDomainScoreDistributionQuery,
  useGetReferralDomainsMutation
} from '../api/backlinkReferralDomainApi';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useExportBacklinkTableMutation } from '../api/exportApi';
import { Col, Row } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import ReferralDomainScoreChart from '../components/ReferralDomainScoreChart';
import ApiLoadError from '@/components/errors/ApiLoadError';
import useBacklinkQueryBody, {
  toOverviewQueryBody
} from '../hooks/useBacklinkQueryBody';


const ReferralDomain = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [exportTable] = useExportBacklinkTableMutation();
  const body = useBacklinkQueryBody();
  const overviewBody = toOverviewQueryBody(body);
  const {
    data: getReferralDomainsRes,
    isFetching: getReferralDomainsLoading,
    isError: getReferralDomainsError,
    error: getReferralDomainsErrorDetails,
    refetch: refetchReferralDomains
  } = useGetReferralDomainsCountQuery({ ...body, page: 1, perPage: 50 });
  const {
    data: scoreDistributionRes,
    isFetching: scoreDistributionLoading,
    isError: scoreDistributionError,
    error: scoreDistributionErrorDetails,
    refetch: refetchScoreDistribution
  } = useGetReferralDomainScoreDistributionQuery(overviewBody);
  const [
    getReferralDomainsFunc,
    {
      isError: isReferralDomainsMutationError,
      error: referralDomainsMutationError,
      isLoading: isReferralDomainsMutationLoading,
      reset: resetReferralDomainsMutation
    }
  ] = useGetReferralDomainsMutation();

  return (
    <>
      <FiltersComponent
        preQueries={searchParams.toString()}
        columns={columns}
      />

      <Row className="g-3 mb-3">
        <Col md={6}>
          {scoreDistributionLoading ? (
            <TextLoading height={400} />
          ) : scoreDistributionError ? (
            <ApiLoadError
              error={scoreDistributionErrorDetails}
              isError={scoreDistributionError}
              onRetry={() => refetchScoreDistribution?.()}
              isRetrying={scoreDistributionLoading}
            />
          ) : (
            <ReferralDomainScoreChart
              title="دامنه‌ها (براساس Domain Authority سایت Moz)"
              data={scoreDistributionRes?.data?.moz_domain_authority}
            />
          )}
        </Col>
        <Col md={6}>
          {scoreDistributionLoading ? (
            <TextLoading height={400} />
          ) : scoreDistributionError ? (
            <ApiLoadError
              error={scoreDistributionErrorDetails}
              isError={scoreDistributionError}
              onRetry={() => refetchScoreDistribution?.()}
              isRetrying={scoreDistributionLoading}
            />
          ) : (
            <ReferralDomainScoreChart
              title="دامنه‌ها (براساس Domain Rating سایت Ahrefs)"
              data={scoreDistributionRes?.data?.domain_from_rating_ahrefs}
            />
          )}
        </Col>
      </Row>

      {!getReferralDomainsLoading ? (
        getReferralDomainsError ? (
          <ApiLoadError
            error={getReferralDomainsErrorDetails}
            isError={getReferralDomainsError}
            onRetry={() => refetchReferralDomains?.()}
            isRetrying={getReferralDomainsLoading}
          />
        ) : isReferralDomainsMutationError ? (
          <ApiLoadError
            error={referralDomainsMutationError}
            isError={isReferralDomainsMutationError}
            onRetry={() => {
              resetReferralDomainsMutation?.();
              refetchReferralDomains?.();
            }}
            isRetrying={isReferralDomainsMutationLoading}
          />
        ) : (
          <AgGridWrapper
            table_name={pathname.split('/').slice(1, 3).join('/')}
            otherOptions={{
              headerHeight: 52
            }}
            settings={{
              pagination: true,
              fullscreen: false,
              changeHeight: false,
              resetGrid: false,
              saveGrid: false,
              sideBar: false,
              export: {
                enabled: true,
                fetchFunction: exportTable,
                additionalData: body
              }
            }}
            stickyHorizontalScroll
            stickyHeader
            height="auto"
            fetchFunction={getReferralDomainsFunc}
            total={getReferralDomainsRes?.data?.total}
            data={getReferralDomainsRes?.data?.rows}
            columns={columns}
            additionalData={body}
          />
        )
      ) : (
        <AgGridSkeleton height="400px" />
      )}
    </>
  );
};

export default ReferralDomain;
